import GaugeWithNeedle from '../../../../../../../components/Charts/GaugeNeedle/GaugeWithNeedle'



export default function GetMetabolicGauge() {

  return (

      <GaugeWithNeedle realAge={52} chronologicalAge={62} />
    
  );
};




